<template>
    <div class="app_main">
        <div class="tac_left">
            <Sidemenu></Sidemenu>
        </div>
        <div class="tac_right">
            <div class="tac_right_top">
                <Navigation></Navigation>
            </div>
            <div class="tac_right_main">
                <router-view/>
            </div>
            <!--            <el-tabs-->
            <!--                v-model="editableTabsValue"-->
            <!--                type="card"-->
            <!--                closable-->
            <!--                @tab-remove="removeTab"-->
            <!--            >-->
            <!--                <el-tab-pane-->
            <!--                    v-for="item in editableTabs"-->
            <!--                    :key="item.name"-->
            <!--                    :label="item.title"-->
            <!--                    :name="item.name"-->
            <!--                >-->
            <!--                    <div class="tac_right_main">-->
            <!--                        <router-view />-->
            <!--                    </div>-->
            <!--                </el-tab-pane>-->
            <!--            </el-tabs>-->
        </div>
    </div>


    <!-- 叫号面板 -->
    <div class="call_number_body flex_c_col">
        <div class="call_number_top flex_c_between">
            <div class="call_num_point_div flex_c_col">
                <div class="call_num_line"></div>
            </div>
            <div class="call_num_point_div flex_c_col">
                <div class="call_num_line"></div>
            </div>
        </div>
        <div :class="isOpenCallNumber ? 'call_number_body_expand flex_t_col': 'call_num_panel flex_t_col'">
            <div class="call_num_panel_line flex_c_between" @click="expandDiv">
                <span class="font_16 font_weight font_white">叫号面板</span>
                <span class="font_16 font_weight font_white" v-if="!isOpenCallNumber"><el-icon><UserFilled /></el-icon></span>
                <span class="font_16 font_weight font_white" v-if="isOpenCallNumber"><el-icon><ArrowDownBold /></el-icon></span>
            </div>
            <div class="call_detail flex_t_col" v-if="isOpenCallNumber">
                <!--预约状态统计 -->
                <div class="call_statistics call_statistics_three flex_c_between">
                    <div v-for="item in callNumberStats" :key="item.key" class="call_statistics_body flex_center">
                        <div :class="['call_statistics_con', 'call_statistics_' + item.key, callNumberTab === item.key ? 'call_statistics_act' : '', 'flex_c_col']"
                             @click="changeQuickPanelTab(item.key)">
                            <div class="call_statistics_num flex_center">{{ item.count }}</div>
                            <div class="call_statistics_label flex_center">{{ item.label }}</div>
                        </div>
                    </div>
                </div>
                <!--正在就诊 -->
                <div class="call_callperson flex_c_left">正在就诊：<span class="callperson_name mrl10">{{ callingName }}</span></div>
                <!--预约列表 -->
                <div class="call_wait flex_t_between">
                    <div class="call_wait_title flex_center">{{ currentCallListTitle }}：</div>
                    <div class="call_wait_con flex_t_col">
                        <div class="call_wait_line flex_c_between" v-for="(item, index) in callNumberList" :key="index">
                            <div>{{ rowLabel(item) }}</div>
                            <div class="flex_c_right" v-if="callNumberTab === 'wait' || callNumberTab === 'jump'">
                                <el-button
                                    type="primary"
                                    size="small"
                                    @click="calling(item)"
                                    :disabled="item.countdown > 0">
                                    {{ item.countdown > 0 ? `叫号（${item.countdown}秒）` : '叫号' }}
                                </el-button>
<!--                                <el-button type="primary" size="small" @click="calling(item)">叫号</el-button>-->
                                <el-button type="success" size="small" @click="callToOrder(item)">接诊</el-button>
                            </div>
                            <div class="flex_c_right" v-else-if="callNumberTab === 'return'">
                                <el-button type="primary" size="small" v-if="item.status === 'WAITING'"
                                           @click="callReturnVisitItem(item)">叫号</el-button>
                                <el-button type="success" size="small" v-if="item.status === 'WAITING'"
                                           @click="receiveReturnVisit(item)">接诊</el-button>
                                <template v-if="item.status === 'CALLED'">
                                    <el-button type="primary" size="small" @click="continueReturnVisit(item)">继续接诊</el-button>
                                    <el-button type="success" size="small" @click="completeReturnVisitItem(item)">完成</el-button>
                                    <el-button type="danger" size="small" @click="cancelReturnVisitItem(item)">取消</el-button>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 提示信息 -->
                <div class="warning_text flex_center">如果需要查询更多信息，请到“<span class="jump_link" @click="changeData('todayreservation')">今日预约</span>”进行查询</div>
            </div>
        </div>
    </div>
</template>
<script>
import Navigation from "@/components/navigation";
import Sidemenu from "@/components/sidemenu";
import {docCallAccptNumber, docCallNumber, getTodayReservationList, getUnifiedClinicQueue, callReturnVisit, completeReturnVisit, cancelReturnVisit} from "@/api";
import {message, getTodayDate, messageHtml, errorMsg} from "@/assets/utils/common";
import {startReservationAutoRefresh, stopReservationAutoRefresh} from "@/assets/utils/reservationRefresh";

export default {
    components: {
        Sidemenu,
        Navigation,
    },
    data() {
        return {
            navselected: 'home',
            editableTabsValue: '1',
            editableTabs: [],
            tabIndex: 1,
            isOpenCallNumber: false,
            waitCnt: 0,
            jumpCnt: 0,
            callCnt: 0,
            waitingList: [],
            jumpList: [],
            callingList: [],
            callingName: null,
            callNumberTab: 'wait',
            doctorInfo: null,
            callNumberList: [],
            callNumberStats: [
                {key: 'wait', label: '待就诊', count: 0},
                {key: 'done', label: '已就诊', count: 0},
                {key: 'jump', label: '已过号', count: 0},
                {key: 'return', label: '回诊', count: 0}
            ],
            callNumberData: {
                wait: [],
                done: [],
                jump: [],
                return: []
            },
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },
            countdown: 0, // 倒计时字段
            isCounting: false, // 是否正在倒计时
            reservationRefreshTimer: null,
        }
    },
    computed: {
        currentCallListTitle() {
            const current = this.callNumberStats.find(item => item.key === this.callNumberTab);
            return current ? current.label : '预约人员';
        }
    },
    created() {
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo") || '{}');
    },
    mounted() {
        this.navselected = this.$route.name;
        this.addTab("工作台");
        startReservationAutoRefresh(this, () => {
            if (this.isOpenCallNumber) {
                this.getQuickPanelDataInfo();
            }
        });
    },
    beforeUnmount() {
        stopReservationAutoRefresh(this);
    },
    methods: {
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
            this.isOpenCallNumber = false;
        },
        getNavType() {
            this.navselected = this.$store.state.adminleftnavnum;
            console.log(this.navselected)
        },
        getCurrentRouteTitle() {
            console.log(this.$store.state.actRouterTitle);
            let actRouterTitle = this.$store.state.actRouterTitle;
            if (actRouterTitle !== '工作台' && this.navselected !== 'home') {
                // this.addTab(actRouterTitle);
            }
        },

        addTab(actRouterTitle) {
            ++this.tabIndex;
            this.editableTabs.push({
                title: actRouterTitle,
                name: actRouterTitle,
                content: '',
            })
            this.editableTabsValue = actRouterTitle;
        },
        removeTab(targetName) {
            let tabs = this.editableTabs
            let activeName = this.editableTabsValue
            if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.name === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1]
                        if (nextTab) {
                            activeName = nextTab.name
                        }
                    }
                })
            }

            this.editableTabsValue = activeName
            this.editableTabs = tabs.filter((tab) => tab.name !== targetName)
        },

        // 叫号面板展开收起
        expandDiv() {
            this.isOpenCallNumber = !this.isOpenCallNumber;
            if (this.isOpenCallNumber) {
                this.getQuickPanelDataInfo();
            }
        },

        // 叫号快捷面板查询
        getQuickPanelDataInfo: function () {
            const data = {
                schDate: getTodayDate(),
                doctorId: this.doctorInfo && this.doctorInfo.doctorId ? this.doctorInfo.doctorId : null
            };
            Promise.all([
                //待就医/已过号按排队号排序（queueOrder=1：签到/现场挂号顺序）
                getTodayReservationList({...data, pageNum: 1, pageSize: 20, reStatus: '5', queueOrder: '1'}),
                getTodayReservationList({...data, pageNum: 1, pageSize: 20, reStatus: '2'}),
                getTodayReservationList({...data, pageNum: 1, pageSize: 20, reStatus: '7', queueOrder: '1'}),
                getTodayReservationList({...data, pageNum: 1, pageSize: 1, reStatus: '6'}),
                // 统一队列失败不应让整个面板空白，单独提示原因后按空队列继续
                // 医生范围由后端按账号绑定关系决定，前端不传 doctorId
                getUnifiedClinicQueue({schDate: data.schDate || getTodayDate()}).catch(error => {
                    message(errorMsg(error, '统一接诊队列加载失败'), 'error');
                    return {data: {code: 200, data: []}};
                })
            ]).then(responses => {
                const waitData = responses[0].data || {};
                const doneData = responses[1].data || {};
                const jumpData = responses[2].data || {};
                const callingData = responses[3].data || {};
                if (waitData.code !== 200 || doneData.code !== 200 || jumpData.code !== 200 || callingData.code !== 200) {
                    return;
                }
                this.callNumberStats[0].count = waitData.total || 0;
                this.callNumberStats[1].count = doneData.total || 0;
                this.callNumberStats[2].count = jumpData.total || 0;
                this.callNumberData.wait = waitData.rows || [];
                this.callNumberData.done = doneData.rows || [];
                this.callNumberData.jump = jumpData.rows || [];
                //回诊叫号在医生端（clinic）进行：取统一队列里的回诊记录，与线上预约交替展示
                //getRequest 返回的是完整 axios 响应，队列数组在 body.data.data 里
                const queueBody = (responses[4] && responses[4].data) || {};
                const queueRows = queueBody.code === 200 ? (queueBody.data || []) : [];
                this.callNumberData.return = queueRows.filter(item => item.queueType === 'RETURN');
                this.callNumberStats[3].count = this.callNumberData.return.length;
                this.callingList = callingData.rows || [];
                const calledReturn = this.callNumberData.return.find(item => item.status === 'CALLED');
                this.callingName = calledReturn ? calledReturn.queueNoText + calledReturn.patientName
                    : this.callingList.length > 0 ? (this.callingList[0].queueSeq || this.callingList[0].reNo) + "号" + this.callingList[0].cardPatientName : null;
                this.waitingList = this.callNumberData.wait;
                this.jumpList = this.callNumberData.jump;
                this.callCnt = this.callingList.length;
                this.waitCnt = waitData.total || 0;
                this.jumpCnt = jumpData.total || 0;
                this.changeQuickPanelTab(this.callNumberTab);
            }).catch(error => {
                message(errorMsg(error, '叫号面板加载失败'), "error");
            });
        },

        // 切换tab
        changeQuickPanelTab(type) {
            this.callNumberTab = type;
            this.callNumberList = [];
            this.callNumberList = (this.callNumberData[type] || []).slice();

            // 初始化每个条目的 countdown 字段
            this.callNumberList = this.callNumberList.map(item => ({
                ...item,
                countdown: 0
            }));
        },


        // 叫号
        calling(row) {
            console.log(row);
            if (row.countdown > 0) return; // 如果正在倒计时，阻止重复点击
            this.startCountdown(row); // 启动倒计时
            let cardPatientName = row.cardPatientName;
            docCallNumber(cardPatientName).then(res => {
                console.log(res);
                if (res.code === 200) {
                    messageHtml("正在呼叫 <span class='font_orange font_18 mrlr10'>"+cardPatientName+"</span> 前往诊室就诊", "success");
                }
            });
        },

        // 启动倒计时
        startCountdown(item) {
            item.countdown = 15;

            const timer = setInterval(() => {
                item.countdown--;

                if (item.countdown <= 0) {
                    clearInterval(timer);
                }
            }, 1000);
        },


        // 接诊
        callToOrder(row) {
            console.log(row);
            this.patientInfo.name = row.cardPatientName;
            this.patientInfo.sex = row.cardPatientSex;
            this.patientInfo.age = row.age;
            this.patientInfo.phoneNumber = row.cardPatientPhone;
            this.patientInfo.identity = row.cardIdentity;
            let reId = row.reId;
            console.log(reId)
            docCallAccptNumber(reId).then(res => {
                console.log(res);
                if (res.code === 200) {
                    this.isOpenCallNumber = false;
                    // 叫号成功后，跳到接诊页面
                    window.sessionStorage.removeItem("reservationPatient");
                    window.sessionStorage.setItem("reservationPatient", JSON.stringify(this.patientInfo));
                    window.dispatchEvent(new CustomEvent('reservationPatientChanged'));

                    this.$router.push({path: '/admin/clinictreat'});
                    this.$store.state.adminleftnavnum = 'clinictreat'; //设置左侧导航2-2 active
                }
            });
        },

        // 队列行文案：预约号与回诊号统一按大屏口径展示（回诊N号、N号）
        rowLabel(item) {
            if (item.queueNoText) {
                return item.queueNoText + (item.patientName || '');
            }
            //预约单显示排队号（签到/现场挂号顺序分配），存量缺号单回退 re_no
            return ((item.queueSeq || item.reNo) || '') + '号' + (item.cardPatientName || '');
        },

        // 回诊叫号：只播报不改状态，与线上预约的叫号口径一致
        callReturnVisitItem(row) {
            docCallNumber(row.patientName).then(res => {
                if (res.code === 200) {
                    messageHtml("正在呼叫 <span class='font_orange font_18 mrlr10'>" + row.patientName + "</span> 前往诊室就诊", "success");
                }
            }).catch(error => {
                //失败必须出声：播报接口被拦或异常时静默会“点了没反应”
                message(errorMsg(error, '回诊叫号失败'), "error");
            });
        },

        // 回诊接诊：置为正在就诊并进入开方页
        receiveReturnVisit(row) {
            callReturnVisit(row.id).then(res => {
                if (res.code === 200) {
                    this.goTreatPage(row);
                } else {
                    message(res.msg || '回诊接诊失败', 'warning');
                }
            }).catch(error => {
                //失败必须出声：接口被拦或状态已变更时静默会导致“点了没反应”
                message(errorMsg(error, '回诊接诊失败'), 'error');
            });
        },

        // 已接诊的回诊重新进入开方页（不改状态）
        continueReturnVisit(row) {
            this.goTreatPage(row);
        },

        // 带患者信息进入开方页，字段与线上预约接诊一致
        goTreatPage(row) {
            this.isOpenCallNumber = false;
            this.patientInfo.name = row.patientName;
            this.patientInfo.sex = row.cardPatientSex;
            //统一队列的回诊条目不带 age，用出生日期换算（与 clinictreat 的 normalizeReturnVisit 同口径）
            this.patientInfo.age = row.age || (row.cardPatientBirth ? new Date().getFullYear() - new Date(row.cardPatientBirth).getFullYear() : null);
            this.patientInfo.phoneNumber = row.cardPatientPhone;
            this.patientInfo.identity = row.cardIdentity;
            window.sessionStorage.removeItem("reservationPatient");
            window.sessionStorage.setItem("reservationPatient", JSON.stringify(this.patientInfo));
            window.dispatchEvent(new CustomEvent('reservationPatientChanged'));

            this.$router.push({path: '/admin/clinictreat'});
            this.$store.state.adminleftnavnum = 'clinictreat'; //设置左侧导航2-2 active
        },

        // 回诊完成
        completeReturnVisitItem(row) {
            completeReturnVisit(row.id).then(res => {
                if (res.code === 200) {
                    messageHtml("已完成 <span class='font_orange font_18 mrlr10'>" + row.patientName + "</span> 的回诊", "success");
                    this.getQuickPanelDataInfo();
                } else {
                    message(res.msg || '回诊完成失败', 'warning');
                }
            }).catch(error => {
                message(errorMsg(error, '回诊完成失败'), 'error');
            });
        },

        // 回诊取消
        cancelReturnVisitItem(row) {
            cancelReturnVisit(row.id).then(res => {
                if (res.code === 200) {
                    messageHtml("已取消 <span class='font_orange font_18 mrlr10'>" + row.patientName + "</span> 的回诊", "success");
                    this.getQuickPanelDataInfo();
                } else {
                    message(res.msg || '回诊取消失败', 'warning');
                }
            }).catch(error => {
                message(errorMsg(error, '回诊取消失败'), 'error');
            });
        },

    },
    watch: {
        // 监测store.state
        '$store.state.adminleftnavnum': 'getNavType',
        '$store.state.actRouterTitle': 'getCurrentRouteTitle'
    }
}
</script>


<style scoped lang="scss">
    @import "@/assets/styles/admin.scss";
</style>
